import React, { useEffect } from 'react';
import ProductsView from 'views/Products';
import { DataProvider } from 'context/ListDataContext';

const ProductsDashboard = () => {
  useEffect(() => {
    localStorage.removeItem('stage1');
    localStorage.removeItem('stage2');
    localStorage.removeItem('stage3');
    localStorage.removeItem('stage4');
    localStorage.removeItem('stage1EmissionTotal');
    localStorage.removeItem('stage2EmissionTotal');
    localStorage.removeItem('stage3EmissionTotal');
    localStorage.removeItem('stage4EmissionTotal');
  }, []);
  return (
    <div>
      <ProductsView />
    </div>
  );
};

export default ProductsDashboard;
